export function getCurrentSiteUser(state) {
  return state.currentSiteUser;
}



// WEBPACK FOOTER //
// ./src/widget/selectors/current-site-user.js